import React, { useState } from 'react';
import AuthenticatedComponent from './AuthenticatedComponent'
import GeneralAssemblyConstants from '../constants/GeneralAssemblyConstants.js';
import DatePicker from 'react-datepicker';
import {  formatDateHyphensReverse, formatDateTimeReverse } from '../helpers/dateFormatter';

function GeneralAssembly(props) {
  const [nonNormalGA, setNonNormalGA] = useState(false);
  const [date, setDate] = useState(new Date());
  const [fuldmagtdate, setFuldmagtdate] = useState(new Date());
  const [place, setPlace] = useState('');

  const generateReport = () => {
    if(place !== ''){
      window.alert("Dette kan tage op til 2 minutter");
      window.open(GeneralAssemblyConstants.GENERAL_ASSEMBLY_URL + "/" + formatDateTimeReverse(date) + "/" + nonNormalGA + "/" + formatDateHyphensReverse(fuldmagtdate) + "/" + place + "/generalforsamling", '_blank');
    } else {
      window.alert('udfyld venligst sted for generalforsamling')
    }
  };

  return (
    <div className="container ">
      <div className="row">
        <div className="standardBackground col-md-4 offset-md-4 standardBackground">
          <div className="form-group">
            <label>Dato og klokkeslæt for generalforsamling</label>
            <DatePicker
              dateFormat="dd/MM/yyyy HH:mm"
              selected={date}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              timeCaption="tid"
              onChange={date => { setDate(date) }}
              className="form-control"
            />
            {/* <input type="text" value={date} onChange={(event) => setDate(event.target.value)} className="form-control" id="phone" /> */}
          </div>
          <div className="form-group">
            <label>Sted for generalforsamling</label>
            <input type="text" value={place} onChange={(event) => setPlace(event.target.value)} className="form-control" id="phone" />
          </div>
          <div className="form-group">
            <label>Fuldmagtsblanket dato</label>
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={fuldmagtdate}
              onChange={date => { setFuldmagtdate(date) }}
              className="form-control"
            />
            {/* <input type="text" value={fuldmagtdate} onChange={(event) => setFuldmagtdate(event.target.value)} className="form-control" id="phone" /> */}
          </div>
          <div className="form-group marginBottom1">
            <label className="col-md-12" >Er det en ekstraordinær generalforsamling?</label>
            <input className="col-md-12" type="checkbox" checked={nonNormalGA} onChange={(event) => setNonNormalGA(event.target.checked)} />
          </div>
          <div className="form-group">
            <button className="btn btn-primary" onClick={() => generateReport()}>Generer dokumenter</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthenticatedComponent(GeneralAssembly)